export const committeeMemberRoutes = [
  {
    path: "/committeemember",
    component: () =>
      import("@/views/CommitteeMember/CommitteeMemberPaymentDisplay.vue"),
  },
  {
    path: "/committeemember/details",
    component: () => import("@/views/CommitteeMember/Create.vue"),
  },
  {
    path: "/committeemember/register",
    component: () => import("@/views/CommitteeMember/Create.vue"),
  },
  {
    path: "/committeemember/paymentdetails",
    component: () =>
      import("@/views/CommitteeMember/CommitteeMembershipPayment.vue"),
  },
  {
    path: "/committeemember/paymentlist/",
    component: () =>
      import("@/views/CommitteeMember/CommitteeMemberPaymentList.vue"),
  },

  {
    path: "/committeemember/transactions/",
    component: () =>
      import("@/views/AdministrationPayment/TransactionList.vue"),
  },
];
